import { apiClient } from './apiClient';
import type { OnboardingStatusResponse } from '../types/onboarding';

/**
 * Drives the relance onboarding walkthrough's per-user consent decision. `complete`/`reactivate` both
 * record the same Completed status server-side — the distinction is which UI flow called it (the
 * walkthrough vs. the Settings re-consent block), not a different backend effect.
 */
const onboardingService = {
    getStatus: () => apiClient.get<OnboardingStatusResponse>('/onboarding/status'),
    complete: () => apiClient.post<void>('/onboarding/complete', {}),
    refuse: () => apiClient.post<void>('/onboarding/refuse', {}),
    reactivate: () => apiClient.post<void>('/onboarding/reactivate', {}),
    markWelcomeSeen: () => apiClient.post<void>('/onboarding/welcome-seen', {}),
};

export { onboardingService };
